import React from "react";
import { NavLink } from "react-router-dom";

const BreadComp = ({title,title0,link}) => {
    return (
        <div className="myaccountBreadcomp">
            <NavLink to="/" className="Myaccounthome-title text-decoration-none">Home</NavLink>
            {
                title0 &&
                <div className="myaccount-breadcomp-slash">/</div>
            }
            {
                title0 &&
                <NavLink to={link} className="Myaccounthome-title text-decoration-none">{title0}</NavLink>
            }
         
           
            <div className="myaccount-breadcomp-slash">/</div>
            <div className="myaccountbreadcomp-activetitle">{title}</div>

        </div>
    )
}
export default BreadComp;